<template>
    <div class="widget" @click="handleClick">
        <span class="icon">
            <img :src="iconFormat(item)" alt="" srcset="" />
        </span>
        <span :class="['text', { length_6: item.name.length === 6 }]">{{ item.name }}</span>
    </div>
</template>

<script>
export default {
    name: "Widget",
    components: {},
    props: {
        item: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            iconFormat(item) {
                return require("../image/" + item.icon + ".png");
            },
        };
    },
    methods: {
        handleClick() {
            this.$emit("callback", this.item);
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    width: 33.33%;
    display: flex;
    cursor: pointer;
    align-items: center;
    padding: 8px 6px;
    .icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        display: inline-block;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .length_6 {
        white-space: nowrap;
    }
}
.widget:hover {
    color: #3a9d80;
    border-radius: 6px;
    background-color: #f5f7fa;
}
</style>
